import React, { useState} from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import {Box,Typography,Container,Button, TextField, InputAdornment} from '@mui/material'
import useMediaQuery from '@mui/material/useMediaQuery';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import {IconButton} from "@mui/material"
import {useSelector, useDispatch} from 'react-redux';
import {useTheme} from '@mui/material/styles'
import { Add, FormatAlignCenter, Mail, Remove} from '@mui/icons-material';
import MultiInput from './MultiInput';


const DestDialog = ({visible,setVisible,handleAdd,setData,data})=>{

	const theme = useTheme()
	const user = useSelector(state => state?.auth.user);
	const size_sm = useMediaQuery(theme.breakpoints.up('sm'));

	const onClose = () => {
		setVisible(false);
	};


return(    
	<Dialog open={visible} onClose={onClose} sx={{borderRadius:10,justifyContent:"center",textAlign:"center"}}>
		<DialogTitle sx={{background:theme.palette.background.default}}> 
			<Box width="90%" display="flex" flexDirection="row" justifyContent="flex-start" alignContent="center">
				<IconButton sx={{marginTop:3}}>
					<MenuIcon/>
				</IconButton>					
				<Typography mr={2} mt={4} style={{fontSize:15,fontWeight:400,fontFamily:"dinofans"}}>
					Add Destination
				</Typography>		
			</Box>
		</DialogTitle>
		<DialogContent m={theme.spacing(1)} sx={{width:{xs:300,md:400},justifyContent:"center",background:theme.palette.background.default}}>
            <Box m={1}>
                <Typography fontSize={14} mb={2} variant="h6" color="gold" sx={{fontFamily:"geruduk"}}>
                   e-mail
                </Typography> 
                <TextField
                    label="email"
                    onChange={(e)=>{setData(e?.target?.value)}}
                    placeholder='subject...'
                    type="email"
                    required
                    sx={{maxWidth:280}}
                    value={data}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment  style={{width:150,justifyContent:"center",alignItems:"center",textAlign:"left"}} position="end">
                                <Mail /> 
                            </InputAdornment>
                        )
                    }}
                />
            </Box> 
            <IconButton onClick={(e)=>{
                e?.preventDefault()
                setVisible(false)
                handleAdd()
            }} sx={{marginTop:3,width:100,background:"gold",color:"#000",borderRadius:1,justifyContent:"center",alignItems:"center"}}>
                <Typography style={{fontSize:12,fontFamily:"dinofans",marginLeft:1,marginTop:1}}>
                    Add 
                </Typography>
            </IconButton>
		</DialogContent>
	</Dialog>
	)
}

export default DestDialog;